<section class="scr-page scr-page--compact container-serv">
  @if (usrSvc.hasPermission('add:products')) {
    <div class="scr-master-detail">
      <div class="head-list scr-card scr-card--padded">
        <tp-page-header
          variant="toolbar"
          class="tp-page-header--flat tp-page-header--stacked"
          title="Servicios"
          [subtitle]="services.length + (services.length === 1 ? ' servicio' : ' servicios')"
        >
          <div class="scr-search">
            <mat-icon class="scr-search__icon" aria-hidden="true">search</mat-icon>
            <input
              type="text"
              class="form-control"
              placeholder="Buscar Servicio"
              [(ngModel)]="searchText"
              />
          </div>
          <button mat-flat-button actions class="scr-btn-primary" type="button" (click)="cleanForm()">
            <mat-icon>add</mat-icon>
            Nuevo servicio
          </button>
        </tp-page-header>
          <div class="list">
            <div class="row serviceListTitle text-left">
              <b>Servicios</b>
            </div>
            <ul class="vehiculos scrollable-content">
              @for (serv of services | filterByServiceName : searchText; track serv) {
                <li
                  class="scr-list-item"
                  [class.scr-list-item--selected]="isSelectedService(serv)"
                  [attr.aria-current]="isSelectedService(serv) ? 'true' : null"
                >
                  <div class="elem-row">
                    <div
                      class="col-md-3 description"
                      style="cursor: pointer"
                      (click)="editService(serv)"
                      >
                      <span>{{ serv.name }}</span>
                    </div>
                    <div class="col-md-7 description">
                      <span>{{ serv.description }}</span>
                    </div>
                    <div class="col-md-1">
                      <span
                        ><b>{{ serv.isOfferedOnline == true ? "Sí" : "No" }}</b></span
                        >
                      </div>
                      <div class="col-md-1">
                        <mat-icon
                          (click)="deleteService(serv)"
                          title="Eliminar servicio"
                          class="align-self-center delete-icon"
                          >delete_outlined</mat-icon
                          >
                        </div>
                      </div>
                    </li>
                  }
                </ul>
                @if ((services | filterByServiceName : searchText).length === 0) {
                  <tp-empty-state
                    icon="design_services"
                    [title]="services.length === 0 ? 'Todavía no hay servicios' : 'Sin resultados'"
                    [message]="services.length === 0 ? 'Creá el primero con «Nuevo servicio».' : 'Probá con otro nombre.'"
                  ></tp-empty-state>
                }
              </div>
            </div>
            <div class="form-container scr-card scr-card--padded">
              <div class="scr-detail-head">
                @if (hasSelectedService()) {
                  <h2 class="scr-section-title">Editando: {{ serviceForm.controls['name'].value }}</h2>
                  <p class="scr-detail-head__sub">{{ serviceForm.controls['description'].value }}</p>
                } @else {
                  <h2 class="scr-section-title">Elegí un servicio de la lista</h2>
                  <p class="scr-detail-head__sub">O completá los datos para crear uno nuevo.</p>
                }
              </div>
              <form [formGroup]="serviceForm" class="service sl-form" (ngSubmit)="onSubmit()">
                <div class="cf-grid">
                  <div class="cf-field cf-field--full">
                    <label class="cf-label" for="sl-name">Nombre *</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                      <input id="sl-name" matInput placeholder="Nombre" name="name" formControlName="name" required />
                    </mat-form-field>
                  </div>
                  <div class="cf-field cf-field--full">
                    <label class="cf-label" for="sl-description">Descripción *</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                      <textarea
                        id="sl-description"
                        matInput
                        matTextareaAutosize="5"
                        type="text"
                        placeholder="Descripción"
                        name="description"
                        formControlName="description"
                        [rows]="4"
                        required
                      ></textarea>
                    </mat-form-field>
                  </div>
                  <div class="cf-field">
                    <label class="cf-label" for="sl-category">Tipo de tarea *</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                      <mat-select
                        id="sl-category"
                        (selectionChange)="onCategoryChange($event.value)"
                        formControlName="categoryId"
                        required
                        placeholder="Elegí un tipo de tarea"
                      >
                        @for (tg of taskGroups; track tg) {
                          <mat-option [value]="tg.id.toString()">
                            {{ tg.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="cf-field">
                    <label class="cf-label" for="sl-subcategory">Subcategoría *</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                      <mat-select id="sl-subcategory" formControlName="subCategoryId" required placeholder="Elegí una subcategoría">
                        @for (j of jobs; track j) {
                          <mat-option [value]="j.id.toString()">
                            {{ j.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="cf-field cf-field--full">
                    <span class="cf-label">Opciones</span>
                    <div class="cf-toggles">
                      <mat-slide-toggle formControlName="isOfferedOnline">Disponible en mobile</mat-slide-toggle>
                    </div>
                  </div>
                  <div class="cf-field cf-field--full">
                    <app-file-uploader
                      [description]="'Foto del servicio'"
                      [settings]="uploadersetting"
                      [name]="'serviceImg'"
                    ></app-file-uploader>
                  </div>
                </div>
                <div class="cf-actions sl-actions">
                  <button mat-flat-button id="guardar" type="submit">
                    Guardar
                  </button>
                </div>
              </form>
                </div>
              </div>
            } @else {
    <tp-page-header title="Servicios" [subtitle]="services.length + (services.length === 1 ? ' servicio' : ' servicios')"></tp-page-header>
  }
</section>
